import React, { useState, useEffect, Fragment } from "react";
import "./Holiday.css";
// import Topbar from "../../../Dashboard.js";
import {
  getHolidays,
  addHoliday,
  updateHoliday,
  deleteHoliday,
} from "../../services/hrms.service";
// import Leftdashboard from "../../../Leftdashboard.js";
import ReadOnlyRow from "./ReadOnlyRow";
import EditableRow from "./EditableRow";

// Helper function to get day name from date
const getDayName = (dateString) => {
  const date = new Date(dateString);
  const days = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];
  return days[date.getDay()];
};

// Holidays
const Holidays = () => {
  const [contacts, setContacts] = useState([]);
  const [addFormData, setAddFormData] = useState({
    holiday_name: "",
    holiday_date: "",
    holiday_type: "National Holiday",
    description: "",
  });
  const [editFormData, setEditFormData] = useState({
    holiday_name: "",
    holiday_date: "",
    holiday_type: "National Holiday",
    description: "",
  });
  const [editContactId, setEditContactId] = useState(null);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);
  const limit = 10;

  const holidayTypes = [
    "National Holiday",
    "Festival",
    "Religious Holiday",
    "Company Holiday",
  ];

  useEffect(() => {
    fetchHolidays(page, selectedYear);
  }, [page, selectedYear]);

  const fetchHolidays = async (pageNum, year) => {
    try {
      setLoading(true);
      setError(null);
      const response = await getHolidays(year, pageNum, limit);

      if (response.status === 1) {
        // Handle both array and object with data property
        const holidaysData = Array.isArray(response.data)
          ? response.data
          : response.data?.data || [];

        // Add day name to each holiday
        const holidaysWithDay = holidaysData.map((holiday) => ({
          ...holiday,
          holiday_day: getDayName(holiday.holiday_date),
        }));

        setContacts(holidaysWithDay);

        // Calculate total pages from response
        const total =
          response.total || response.data?.total || holidaysData.length;
        setTotalPages(Math.ceil(total / limit));
      } else {
        setContacts([]);
        setError(response.message || "Failed to fetch holidays");
      }
    } catch (error) {
      console.error("Error fetching holidays:", error);
      setError("Failed to load holidays. Please try again.");
      setContacts([]);
    } finally {
      setLoading(false);
    }
  };

  const handleAddFormChange = (event) => {
    const { name, value } = event.target;
    setAddFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleAddFormSubmit = async (event) => {
    event.preventDefault();
    try {
      setLoading(true);
      setError(null);
      setSuccessMessage(null);

      const response = await addHoliday(addFormData);

      if (response.status === 1) {
        setSuccessMessage("Holiday added successfully!");
        fetchHolidays(page, selectedYear);
        setAddFormData({
          holiday_name: "",
          holiday_date: "",
          holiday_type: "National Holiday",
          description: "",
        });
        setTimeout(() => setSuccessMessage(null), 3000);
      } else {
        setError(response.message || "Failed to add holiday");
      }
    } catch (error) {
      console.error("Error adding holiday:", error);
      setError(
        error.response?.data?.message ||
          "Failed to add holiday. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  const handleEditClick = (event, contact) => {
    event.preventDefault();
    setEditContactId(contact.id);
    setEditFormData({
      holiday_name: contact.holiday_name || "",
      holiday_date: contact.holiday_date || "",
      holiday_type: contact.holiday_type || "National Holiday",
      description: contact.description || "",
    });
  };

  const handleEditFormChange = (event) => {
    const { name, value } = event.target;
    setEditFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleEditFormSubmit = async (event) => {
    event.preventDefault();
    try {
      setLoading(true);
      setError(null);
      setSuccessMessage(null);

      const response = await updateHoliday(editContactId, editFormData);

      if (response.status === 1) {
        setSuccessMessage("Holiday updated successfully!");
        fetchHolidays(page, selectedYear);
        setEditContactId(null);
        setTimeout(() => setSuccessMessage(null), 3000);
      } else {
        setError(response.message || "Failed to update holiday");
      }
    } catch (error) {
      console.error("Error editing holiday:", error);
      setError(
        error.response?.data?.message ||
          "Failed to update holiday. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  const handleCancelClick = () => {
    setEditContactId(null);
    setError(null);
  };

  const handleDeleteClick = async (contactId) => {
    if (!window.confirm("Are you sure you want to delete this holiday?")) {
      return;
    }

    try {
      setLoading(true);
      setError(null);
      setSuccessMessage(null);

      const response = await deleteHoliday(contactId);

      if (response.status === 1) {
        setSuccessMessage("Holiday deleted successfully!");
        fetchHolidays(page, selectedYear);
        setTimeout(() => setSuccessMessage(null), 3000);
      } else {
        setError(response.message || "Failed to delete holiday");
      }
    } catch (error) {
      console.error("Error deleting holiday:", error);
      setError(
        error.response?.data?.message ||
          "Failed to delete holiday. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  const handlePreviousPage = () => {
    if (page > 1) {
      setPage(page - 1);
    }
  };

  const handleNextPage = () => {
    if (page < totalPages) {
      setPage(page + 1);
    }
  };

  const handleYearChange = (event) => {
    const newYear = parseInt(event.target.value);
    setSelectedYear(newYear);
    setPage(1); // Reset to first page when year changes
  };

  // Generate year options (current year ± 5 years)
  const currentYear = new Date().getFullYear();
  const yearOptions = [];
  for (let i = currentYear - 2; i <= currentYear + 3; i++) {
    yearOptions.push(i);
  }

  return (
    <div className="Holidays">
      {/* <Topbar /> */}
      <div className="container-fluid my-3">
        <div className="row">
          {/* <Leftdashboard /> */}
          <main className="mainBodyContainer">
            <div className="row mb-3">
              <div className="col-12 py-2 px-3 d-flex justify-content-between align-items-center">
                <h4
                  className="text-capitalize mb-0"
                  style={{ fontFamily: "ErasDemiITC" }}
                >
                  Manage Holidays
                </h4>
                <div className="d-flex align-items-center gap-3">
                  <label
                    className="mb-0"
                    style={{ fontFamily: "Calibri", fontWeight: "600" }}
                  >
                    Year:
                  </label>
                  <select
                    value={selectedYear}
                    onChange={handleYearChange}
                    className="form-select"
                    style={{ width: "auto", fontFamily: "Calibri" }}
                  >
                    {yearOptions.map((year) => (
                      <option key={year} value={year}>
                        {year}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>

            {/* Success/Error Messages */}
            {successMessage && (
              <div
                className="alert alert-success alert-dismissible fade show"
                role="alert"
              >
                {successMessage}
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setSuccessMessage(null)}
                  aria-label="Close"
                ></button>
              </div>
            )}
            {error && (
              <div
                className="alert alert-danger alert-dismissible fade show"
                role="alert"
              >
                {error}
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setError(null)}
                  aria-label="Close"
                ></button>
              </div>
            )}

            <div className="row mb-4">
              <div
                className="col-12 bg-white p-4 rounded-3 shadow-sm"
                style={{}}
              >
                <div className="row">
                  <div
                    className="col-12 col-md-4 mb-3"
                    style={{ backgroundColor: "#F4F7FC" }}
                  >
                    <h5
                      className="mb-3"
                      style={{ fontFamily: "Calibri", fontWeight: "600" }}
                    >
                      Add New Holiday
                    </h5>
                    <form onSubmit={handleAddFormSubmit} className="p-3">
                      <label
                        className="form-label"
                        style={{ fontFamily: "Calibri", fontWeight: "500" }}
                      >
                        Holiday Name <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        name="holiday_name"
                        required="required"
                        onChange={handleAddFormChange}
                        value={addFormData.holiday_name}
                        className="form-control mb-3"
                        placeholder="e.g., New Year's Day"
                      />
                      <label
                        className="form-label"
                        style={{ fontFamily: "Calibri", fontWeight: "500" }}
                      >
                        Holiday Date <span className="text-danger">*</span>
                      </label>
                      <input
                        type="date"
                        name="holiday_date"
                        required="required"
                        onChange={handleAddFormChange}
                        value={addFormData.holiday_date}
                        className="form-control mb-3"
                      />
                      <label
                        className="form-label"
                        style={{ fontFamily: "Calibri", fontWeight: "500" }}
                      >
                        Holiday Type <span className="text-danger">*</span>
                      </label>
                      <select
                        name="holiday_type"
                        required="required"
                        onChange={handleAddFormChange}
                        value={addFormData.holiday_type}
                        className="form-control mb-3"
                      >
                        {holidayTypes.map((type) => (
                          <option key={type} value={type}>
                            {type}
                          </option>
                        ))}
                      </select>
                      <label
                        className="form-label"
                        style={{ fontFamily: "Calibri", fontWeight: "500" }}
                      >
                        Description
                      </label>
                      <textarea
                        name="description"
                        onChange={handleAddFormChange}
                        value={addFormData.description}
                        className="form-control mb-3"
                        rows="3"
                        placeholder="Optional description about the holiday"
                      />
                      <button
                        type="submit"
                        className="btn w-100"
                        style={{ backgroundColor: "#3a3285", color: "#fff" }}
                        disabled={loading}
                      >
                        {loading ? "Adding..." : "Add Holiday"}
                      </button>
                    </form>
                  </div>
                  <div className="col-12 col-md-8">
                    <h5
                      className="mb-3"
                      style={{ fontFamily: "Calibri", fontWeight: "600" }}
                    >
                      Holidays List ({selectedYear})
                    </h5>
                    {loading && contacts.length === 0 ? (
                      <div className="text-center py-5">
                        <div
                          className="spinner-border text-primary"
                          role="status"
                        >
                          <span className="visually-hidden">Loading...</span>
                        </div>
                        <p className="mt-2" style={{ fontFamily: "Calibri" }}>
                          Loading holidays...
                        </p>
                      </div>
                    ) : contacts.length === 0 ? (
                      <div className="text-center py-5">
                        <p style={{ fontFamily: "Calibri", color: "#6c757d" }}>
                          No holidays found for {selectedYear}. Add a new
                          holiday to get started.
                        </p>
                      </div>
                    ) : (
                      <>
                        <form onSubmit={handleEditFormSubmit}>
                          <div className="table-responsive">
                            <table className="table table-striped table-hover">
                              <thead>
                                <tr
                                  className="text-uppercase"
                                  style={{
                                    lineHeight: "20px",
                                    fontFamily: "Calibri",
                                    fontSize: "14px",
                                    backgroundColor: "white",
                                  }}
                                >
                                  <th className="py-3">Holiday Name</th>
                                  <th className="py-3">Date</th>
                                  <th className="py-3">Day</th>
                                  <th className="py-3">Type</th>
                                  <th className="py-3">Action</th>
                                </tr>
                              </thead>
                              <tbody
                                style={{
                                  lineHeight: "20px",
                                  fontFamily: "Calibri",
                                  fontSize: "16px",
                                }}
                              >
                                {contacts.map((contact) => (
                                  <Fragment key={contact.id}>
                                    {editContactId === contact.id ? (
                                      <EditableRow
                                        editFormData={editFormData}
                                        handleEditFormChange={
                                          handleEditFormChange
                                        }
                                        handleCancelClick={handleCancelClick}
                                        holidayTypes={holidayTypes}
                                      />
                                    ) : (
                                      <ReadOnlyRow
                                        contact={contact}
                                        handleEditClick={handleEditClick}
                                        handleDeleteClick={handleDeleteClick}
                                      />
                                    )}
                                  </Fragment>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        </form>

                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            marginTop: "1rem",
                          }}
                        >
                          <div
                            style={{ fontFamily: "Calibri", color: "#6c757d" }}
                          >
                            Showing page {page} of {totalPages}
                          </div>
                          <div className="pagination">
                            <button
                              className="btn btn-sm"
                              onClick={handlePreviousPage}
                              disabled={page === 1 || loading}
                              style={{
                                cursor: page === 1 ? "not-allowed" : "pointer",
                                backgroundColor: "#3a3285",
                                color: "#fff",
                                marginRight: "0.5rem",
                              }}
                            >
                              &lt; Previous
                            </button>
                            <button
                              className="btn btn-sm"
                              onClick={handleNextPage}
                              disabled={page === totalPages || loading}
                              style={{
                                cursor:
                                  page === totalPages
                                    ? "not-allowed"
                                    : "pointer",
                                backgroundColor: "#3a3285",
                                color: "#fff",
                              }}
                            >
                              Next &gt;
                            </button>
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>
    </div>
  );
};

export default Holidays;

// useEffect(() => {
//   if (employeeData?.status) {
//     setSelectedStatus(employeeData.status);
//   }
// }, [employeeData]);
// const handleSelect = async (status) => {
//   setSelectedStatus(status);

//   // Optional: Send updated status to backend
//   try {
//     await axios.post(`${Constant.BASE_URL}hrms/updateEmployeeStatus`, {
//       id: employeeData.id,
//       status,
//     });
//     // Optionally re-fetch to sync data
//     fetchEmployeeDetails(employeeData.id);
//   } catch (error) {
//     console.error("Failed to update status", error);
//   }
// };
// <div className="dropdown">
// <button
//   className="btn btn-primary dropdown-toggle"
//   type="button"
//   id="dropdownMenuButton1"
//   data-bs-toggle="dropdown"
//   aria-expanded="false"
// >
//   {selectedStatus || "Select Status"}
// </button>
// <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
//   <li>
//     <button className="dropdown-item" onClick={() => handleSelect("Active User")}>
//       Active User
//     </button>
//   </li>
//   <li>
//     <button className="dropdown-item" onClick={() => handleSelect("Inactive User")}>
//       Inactive User
//     </button>
//   </li>
// </ul>
// </div>
